import { render, staticRenderFns } from "./TabsMenu.vue?vue&type=template&id=4826d4c9&scoped=true&"
import script from "./TabsMenu.vue?vue&type=script&lang=js&"
export * from "./TabsMenu.vue?vue&type=script&lang=js&"
import style0 from "./TabsMenu.vue?vue&type=style&index=0&id=4826d4c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4826d4c9",
  null
  
)

export default component.exports